import { ModelBase } from './base';

export class Address extends ModelBase{
  street: string;
  number: string;
  city: string;
  country: string;
  zip_code: string;
  type: AddressType;
}

export class AddressType {
  name: string;
  description: string;
  uuid: string;
}



// WEBPACK FOOTER //
// ./src/models/address.ts